export default function PageHeader({
  title,
  subtitle,
  actions = null,
  chips = [],
}) {
  return (
    <div className="page-header">
      <div className="page-header-copy">
        <h2 className="page-title">{title}</h2>
        {subtitle && <p className="page-subtitle">{subtitle}</p>}
        {chips.length > 0 && (
          <div className="flex flex-wrap gap-2 mt-3">
            {chips.map((chip) => (
              <span key={chip} className="stat-chip">
                {chip}
              </span>
            ))}
          </div>
        )}
      </div>
      {actions ? <div className="page-actions">{actions}</div> : null}
    </div>
  )
}
